import BaseTable from "../BaseTable";
import BannerModals from "@/Modals/ContentManagement/Banners/Modal";
import Columns from "./Columns"; // Default import
import { bannersApi } from "@/apis/apis";

export default function BannersPage() {
  return (
    <>
      <BaseTable
        label="Banner"
        apiURL={bannersApi}
        columns={Columns()}
        ModalComponent={BannerModals}
        importData={null}
        enableSortData={true}
        confirmationModalTitleKey="title"
      />
    </>
  );
}
